import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { ConciliacaoService } from '../../services/conciliacao.service';
import { OrigemLancamento } from '../../../../../shared/models/enums/origem-lancamento';
import { BancoOrigemEnumNome } from '../../../../../shared/models/enums/banco-origem-enum';
import { FiltroDialogComponent, FiltroDialogData } from './filtro-dialog/filtro-dialog.component';
import { BuscaEmMassaDialogComponent } from './busca-em-massa-dialog/busca-em-massa-dialog.component';
import { CorrespondenciasDiferencaDialogComponent } from './correspondencias-diferenca-dialog/correspondencias-diferenca-dialog.component';
import { ModoPaginaEnum } from '../../../../../models/enum/modo-pagina-enum';
import { Lancamento } from '../../models/lancamento';

@Component({
  selector: 'app-card-busca',
  standalone: false,
  templateUrl: './card-busca.component.html',
  styleUrl: './card-busca.component.scss'
})
export class CardBuscaComponent implements OnInit, OnDestroy {

  excelFileType: string = ".xlsx";
  resultadosConciliados: Lancamento[][] = []
  existeResultadosConciliados: boolean = false;
  // Index da correspondencia buscado para desfazer a correspondencia
  correspondenciaConciliacaoIndex: number | null = null;

  origemBanco = OrigemLancamento.Banco;
  origemCaixa = OrigemLancamento.Caixa;

  permiteConciliar: boolean = false;

  subscriptions: Subscription[] = [];

  get tipoBancoNome(): string { return BancoOrigemEnumNome.get(this.conciliacaoService.tipoBanco) as string }

  get buscarEm(): OrigemLancamento { return this.conciliacaoService.buscarEm; }
  set buscarEm(value: OrigemLancamento) { this.conciliacaoService.buscarEm = value; }

  get searchValue(): number { return this.conciliacaoService.searchValue; }
  set searchValue(value: number) { this.conciliacaoService.searchValue = value; }

  get targetIsPositive(): boolean { return this.conciliacaoService.targetIsPositive; }
  set targetIsPositive(value: boolean) { this.conciliacaoService.targetIsPositive = value; }

  get searching(): boolean { return this.conciliacaoService.searching; }

  get diferencaValoresSelecionados(): OrigemLancamento { return this.conciliacaoService.diferencaValoresSelecionados; }

  get modoEdicao(): boolean { return this.conciliacaoService.modoPagina === ModoPaginaEnum.Edicao; }

  constructor(
    private conciliacaoService: ConciliacaoService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(this.conciliacaoService.applySearch.subscribe((permiteCorrespondencia: boolean) => this.applySearch(permiteCorrespondencia, permiteCorrespondencia)));
    this.subscriptions.push(this.conciliacaoService.exibeCorrespondencia.subscribe((correspondenciaIndex: number) => this.exibeCorrespondencia(correspondenciaIndex)));
    this.subscriptions.push(this.conciliacaoService.updateCorrespondenciaConciliacaoIndex.subscribe((correspondenciaIndex: number | null) => this.updateCorrespondenciaConciliacaoIndex(correspondenciaIndex)));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private updateResultadosConciliados(): void {
    this.existeResultadosConciliados = !(this.resultadosConciliados.length === 0 || (this.resultadosConciliados.length === 1 && this.resultadosConciliados[0].length === 0));
  }

  public applySearch(permiteConciliar: boolean, buscandoLancamentos: boolean): void {
    this.correspondenciaConciliacaoIndex = null;
    this.permiteConciliar = permiteConciliar;
    this.conciliacaoService.searchForValue(this.searchValue, this.buscarEm, buscandoLancamentos).then((result: any[]) => {
      this.resultadosConciliados = result;
      this.updateResultadosConciliados();
    });
  }

  public exibeCorrespondencia(correspondenciaIndex: number): void {
    this.correspondenciaConciliacaoIndex = correspondenciaIndex;
    const correspondencia = this.conciliacaoService.correspondenciasConciliacao[correspondenciaIndex];

    if (this.conciliacaoService.buscarEm === OrigemLancamento.Banco)
      this.resultadosConciliados = [correspondencia.lancamentosBanco];
    else
      this.resultadosConciliados = [correspondencia.lancamentosCaixa];
    
    this.updateResultadosConciliados();
  }

  public buscarDiferenca(): void {
    this.searchValue = this.diferencaValoresSelecionados;
    this.applySearch(false, false);
  }

  public aceitarCorrespondenciaSelecionado(): void {
    this.conciliacaoService.aceitarCorrespondenciaSelecionada();
  }

  public aceitarCorrespondenciaSugeridoClick(index: number): void {
    const correspondencia = this.resultadosConciliados[index];
    this.conciliacaoService.aceitarCorrespondenciaSugeridaClick(correspondencia);
  }

  public removerCorrespondenciaClick(): void {
    this.conciliacaoService.removerCorrespondenciaClick(this.correspondenciaConciliacaoIndex as number);
  }

  public openFilters(): void {
    this.abrirFiltroDialog({ modoBuscaEmMassa: false });
  }

  public openFiltrosBuscaEmMassa(): void {
    const dialogRef = this.abrirFiltroDialog({ modoBuscaEmMassa: true });

    // "Buscar em Massa" fecha com true; "Cancelar" e o X do header fecham com false.
    dialogRef.afterClosed().subscribe((aplicado: boolean) => {
      if (aplicado) this.abrirBuscaEmMassaDialog();
    });
  }

  private abrirFiltroDialog(data: FiltroDialogData): MatDialogRef<FiltroDialogComponent> {
    return this.dialog.open(FiltroDialogComponent, {
      width: '720px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
      data
    });
  }

  public openCorrespondenciasComDiferenca(): void {
    this.dialog.open(CorrespondenciasDiferencaDialogComponent, {
      width: '750px',
      maxWidth: '95vw',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
    });
  }

  private abrirBuscaEmMassaDialog(): void {
    this.dialog.open(BuscaEmMassaDialogComponent, {
      width: '650px',
      maxWidth: '95vw',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
  }

  private updateCorrespondenciaConciliacaoIndex(correspondenciaIndex: number | null): void {
    this.correspondenciaConciliacaoIndex = correspondenciaIndex;
    if (correspondenciaIndex !== null)
      this.exibeCorrespondencia(correspondenciaIndex)
  }
}
